/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule, PatientBannerModule } from '@core/lib/components';
import { ArchiveAdoptedModalComponent } from './archive-adopted/archive-adopted-modal.component';
import { UserPreferenceComponent } from './user-preference/user-preference.component';
import { SaveExamComponent } from './folders/save-exam.component';
import { FolderMaintenanceComponent } from './folders/folder-maintenance.component';
import { DeleteFolderComponent } from './folders/delete-folder.component';
import { DirectivesModule } from '@core/lib/directives';
import { AssignmentConfirmationComponent } from '@app/common/modals/components/assignment-confirmation/assignment-confirmation.component';
import { AssignExamComponent } from '@app/common/modals/components/assign-exam/assign-exam.component';
import { AppPipesModule } from '@app/common/pipes/app-pipes.module';
import { PipesModule } from '@wfm/core';
import { PatientConfidentialComponent } from '@app/common/modals/components/patient-confidential/patient-confidential.component';
import { AssignToMeConfirmationComponent } from './assign-to-me-confirmation/assign-to-me-confirmation.component';
import { CoReaderDialogComponent } from '@app/common/modals/components/co-reader/co-reader-dialog.component';
import { AppComponentsModule } from '@app/common/components/app-components.module';
import { AuditTrailComponent } from './audit-trail/audit-trail.component';
import { VirtualGridComponentsModule } from '@wfm/virtual-grid';
import { AdvanceSearchComponent } from './advance-search/advance-search.component';
import { SaveWorkListComponent } from './save-work-list/save-work-list.component';
import { AngularResizedEventModule } from 'angular-resize-event';
import { DesignatedAuthorComponent } from './designated-author/designated-author.component';
import { MicroAppShellComponent } from '@app/di/channel/microapp/micro-app-shell/micro-app-shell.component';

@NgModule({
  imports: [
    CommonModule,
    AngularSvgIconModule,
    ComponentsModule,
    FormsModule,
    TranslateModule,
    DirectivesModule,
    PipesModule,
    AppPipesModule,
    AppComponentsModule,
    PatientBannerModule,
    VirtualGridComponentsModule,
    AngularResizedEventModule
  ],
  exports: [
    ArchiveAdoptedModalComponent,
    UserPreferenceComponent,
    SaveExamComponent,
    AssignmentConfirmationComponent,
    AssignExamComponent,
    AssignToMeConfirmationComponent,
    CoReaderDialogComponent,
    DesignatedAuthorComponent
  ],
  declarations: [
    ArchiveAdoptedModalComponent,
    UserPreferenceComponent,
    SaveExamComponent,
    FolderMaintenanceComponent,
    DeleteFolderComponent,
    AssignmentConfirmationComponent,
    AssignExamComponent,
    PatientConfidentialComponent,
    AssignToMeConfirmationComponent,
    CoReaderDialogComponent,
    DesignatedAuthorComponent,
    AuditTrailComponent,
    AdvanceSearchComponent,
    SaveWorkListComponent,
    MicroAppShellComponent
  ],
  entryComponents: []
})
export class ModalComponentsModule {}
